import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {TableLeaguePage} from '../table-league-page.js';

import {competitionsKnockoutGridFactory} from './competitions-knockout-grid.factory.js';

import PALETTE_SCHEMA from './competitions-knockout-grid.palette-schema.yaml';

class CompetitionsKnockoutGridFeature extends AbstractVisualFeature {
    get name() {
        return 'CompetitionsKnockoutGrid';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(competitionsKnockoutGridFactory(PALETTE), {
            EventBracketMarketOptions: {
                matchResultMarketTypes: ['MRES'],
                winnerMarketTypes: ['WIN', 'DNOB', 'TQAL', 'QUAL', 'H2HT', 'HTOH'],
            },
        });
    }
}

new CompetitionsKnockoutGridFeature(TableLeaguePage);
